export default "__VITE_ASSET__66928387__"